import en from './en'

export default {
  en: { common: en },
}
